/**
 * Android platform files
 */

export {projectConfig, dependencyConfig} from './config';
export {getAndroidProject, getPackageName} from './config/getAndroidProject';
export {default as isProjectUsingKotlin} from './config/isProjectUsingKotlin';
